<footer class="footer">
  <div class="footer-links">
    <div class="row">
      <div class="col-2">
        <ul>
          <li class="footer-link-title" [innerHTML]="translate['footer.privacyCenter']"></li>
          <li>
            <a
              [href]="privacyCenterUrl" target="_blank" [innerHTML]="translate['footer.connectedPrivacyPolicy']"></a
            >
          </li>
          <li>
             <a [href]="privacyPolicyUrl" target="_blank" [innerHTML]="translate['footer.privacyPolicy']"></a
            >
          </li>
          <li><a class="disableClick" href="#" (click)="preventClick($event)" role="button" [innerHTML]="translate['footer.cookies']"></a></li>
        </ul>
      </div>
      <div class="col-2">
        <ul>
          <li class="footer-link-title" [innerHTML]="translate['footer.legal']"></li>
          <li>
            <a [href]="connectedTermsAndServiceUrl" target="_blank" [innerHTML]="translate['footer.connectedTermsOfService']"></a
            >
          </li>
          <li>
            <a
              [href]= "websiteTermsofUseUrl" target="_blank" [innerHTML]="translate['footer.websiteTermsOfUse']"></a>
          </li>
          <li>
            <a [href]="manageYourPrivacyChoicesUrl" target="_blank" [innerHTML]="translate['footer.manageYourPrivacyChoices']"></a
            >
          </li>
        </ul>
      </div>
      <div class="col">
        <ul>
          <li class="footer-link-title" [innerHTML]="translate['footer.support']"></li>
          <li>
            <a [href]="contactUrl" target="_blank" [innerHTML]="translate['footer.contact']"></a
            >
          </li>
          <li><a [routerLink]="['/faq']" [innerHTML]="translate['footer.faq']"></a></li>
          <li><a href="#" (click)="preventClick($event)" [innerHTML]="translate['footer.plansAndPricing']"></a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="social-bar">
    <div class="row">
      <div class="col">
        <ul>
          <li><a [href]="twitterUrl" target="_blank" ><img alt="" [src]="twitterIcon" /></a></li>
          <li><a [href]="facebookUrl" target="_blank" ><img alt="" [src]="facebookIcon" /></a></li>
          <li><a [href]="instagramUrl" target="_blank" > <img alt="" [src]="instagramIcon" /></a></li>
          <li><a [href]="linkedInUrl" target="_blank" ><img alt="" [src]="linkedInIcon" /></a></li>
          <li><a [href]="youTubeUrl" target="_blank" ><img alt="" [src]="youTubeIcon" /></a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
